module.exports = __webpack_public_path__ + "static/media/02B2.f85ee11f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/02B2.png
// module id = 268
// module chunks = 0